import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';

import { Radiobutton } from '../Radiobutton/Radiobutton';
import { Container, InputsContainer } from './YesNoCheckbox.styles';
import { YesNoCheckboxProps } from './YesNoCheckbox.types';

export const YesNoCheckBox = ({
  label,
  checked,
  children,
  user,
  onClick,
  padding,
}: YesNoCheckboxProps): JSX.Element => {
  const { t } = useTranslation(['common']);

  return (
    <Container padding={padding}>
      {label ?? null}
      <InputsContainer>
        <Radiobutton
          checked={checked !== undefined && checked}
          labelText={upperFirst(t('yes'))}
          onClick={onClick.bind(null, true)}
          user={user}
        />
        <Radiobutton
          checked={checked !== undefined && !checked}
          labelText={upperFirst(t('no'))}
          onClick={onClick.bind(null, false)}
          user={user}
        />
      </InputsContainer>
      {children ?? null}
    </Container>
  );
};
